"use client";

import React from "react";

import UiTooltip from "@/components/Ui/Tooltip";
import useApiEnvSwitch from "@/hooks/api-env/useApiEnvSwitch";

import SupUiLoading from "@/components/Ui/Loading";
import { SupOption, SupSelect, SupText } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

export default function AccountSwitchEnv() {
  const { displayApiEnv, apiEnv, isLoading, options, switchAllowed, setApiEnv } = useApiEnvSwitch();

  return (
    displayApiEnv && (
      <div className="flex flex-col items-center">
        {isLoading ? (
          <SupUiLoading isSmall />
        ) : (
          <UiTooltip content="API Origin switch is disabled for this env" enable={!switchAllowed} arrowPlacement="left">
            <div className={twMerge("flex items-center", !switchAllowed && "cursor-not-allowed")}>
              <SupSelect
                disabled={!switchAllowed}
                value={apiEnv}
                className="relative h-5 w-fit whitespace-nowrap border-none bg-transparent pl-0.5 hover:bg-transparent focus:bg-transparent active:bg-transparent [&.disabled]:bg-transparent [&.disabled]:text-neutral-300"
                popoverClassName="p-0 min-w-36"
                popoverContentClassName="p-0"
                onSelect={setApiEnv}
                renderOptionLabel={option => (
                  <SupText variant="caption" className="w-full text-base md:text-[12px]">
                    {option.label}
                  </SupText>
                )}
                optionClassName="h-6 p-2"
              >
                {options.map(apiEnvOption => (
                  <SupOption key={`switch-env-value-${apiEnvOption.value}`} label={apiEnvOption.label} value={apiEnvOption.value} />
                ))}
              </SupSelect>
            </div>
          </UiTooltip>
        )}
      </div>
    )
  );
}
